
    import { Component, Vue } from 'vue-property-decorator'

    const ContactUs = () => import('./components/ContactUs.vue')
    const SearchBox = () => import('./components/SearchBox.vue')

    @Component({
        components: {
            ContactUs,
            SearchBox
        }
    })

    export default class App extends Vue {
        dialog = false
        dealerPortalUrl = ''
        drawer = false
        logoUrl = ''
        logoWebsite = './img/FDP_Logo_1_Web.png'
        logoContractPage = '/img/FDP_Logo_Contract_Page.png'

        created() {
            this.dealerPortalUrl = process.env.VUE_APP_DEALER_PORTAL_URL ?? '';
            
            // Start - Nghia Nguyen - Feb 6, 2025 - #17026 - FDP Website Update
            this.logoUrl = this.logoWebsite;

            this.$watch(
                () => this.$route.name,
                (newRoute) => {
                    if (newRoute === 'ContractManufacturing') {
                        this.logoUrl = this.logoContractPage;
                    } else {
                        this.logoUrl = this.logoWebsite;
                    }
                }
            );
            // End - Nghia Nguyen - Feb 6, 2025 - #17026 - FDP Website Update
        }
    }
